import { DistributorList } from '@Resources/distributor/DistributorList';
import { ResourceDefinition } from '@Utils/types';

export const distributorResource: ResourceDefinition = {
  options: { label: 'menu.distributor' },
  list: DistributorList,
};
